import React from 'react'

const RoundedBackground = (props) => {
  const { x, y, width, height } = props
  const radius = 8
  return (
    <rect
      x={x}
      y={y}
      width={width}
      height={height}
      rx={radius}
      ry={radius}
      fill="#ffffff10"
    />
  )
}

export default RoundedBackground